export enum SubscriptionStatus {
    Trial = "Trial",
    TrialExpired = "TrialExpired",
    PayingClient = "PayingClient",
    FailedPayment = "FailedPayment",
    Deactivated = "Deactivated", 
};